import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { doLogout } from "../../../../store/reducer/_sessionReducer";

import { Logo } from "../../../components/global";

import { useNavigate } from "react-router";
import { getLoggedUser } from "../../../../store/selectors";
import { ssoUserManager } from "../../../../utils/sso";
import "../index.scss";

const SSOLogout = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const loggedUser = useSelector(getLoggedUser);

  useEffect(() => {
    const logout = async () => {
      try {
        if (!loggedUser) {
          navigate("/login");
          return;
        }

        const idToken = sessionStorage.getItem("sso_id_token");

        dispatch(doLogout());

        sessionStorage.removeItem("sso_id_token");

        await ssoUserManager.removeUser();

        await ssoUserManager.signoutRedirect({
          id_token_hint: idToken,
        });
      } catch (err) {
        console.error("Erro logout SSO", err);

        sessionStorage.clear();
        localStorage.clear();

        window.location.href = "/login";
      }
    };

    logout();
  }, [dispatch]);

  return (
    <div className="auth-section">
      <Logo variant="lex" />

      <h2>Encerrando sessão...</h2>
    </div>
  );
};

export default SSOLogout;
